import React, { useEffect, useState } from "react";
import { Modal, Table, Spin, Avatar, Tag } from "antd";
import { TrophyTwoTone } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { scoreColor, formatTime } from "./evalDashboardUtils";
import styles from "./TeacherEvalDashboard.module.scss";

const MEDAL = ["#FFC53D", "#BFBFBF", "#D48806"]; // oro, plata, bronce

// T5 — Ranking de un examen en una clase (mejor marca). Reusa getRankingResults.
export function RankingModal({
  open,
  onClose,
  quiz,
  classnumber,
  loadRanking,
}) {
  const { t } = useTranslation("evaluations");
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    let active = true;
    (async () => {
      if (!open || !quiz?._id || !classnumber) return;
      setLoading(true);
      const data = await loadRanking(quiz._id, classnumber);
      if (active) {
        setRows(data || []);
        setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [open, quiz, classnumber, loadRanking]);

  const columns = [
    {
      title: "#",
      key: "pos",
      width: 60,
      render: (_, __, idx) =>
        idx < 3 ? (
          <TrophyTwoTone twoToneColor={MEDAL[idx]} style={{ fontSize: 18 }} />
        ) : (
          idx + 1
        ),
    },
    {
      title: t("dashboard.colStudent"),
      dataIndex: "studentName",
      key: "studentName",
      ellipsis: true,
      render: (v) => (
        <div className={styles.studentCell}>
          <Avatar size={26}>{(v || "?").charAt(0).toUpperCase()}</Avatar>
          <span className={styles.studentName}>{v}</span>
        </div>
      ),
    },
    {
      title: t("dashboard.colCorrect"),
      key: "correct",
      width: 110,
      align: "center",
      render: (_, r) => {
        const total = (r.totalCorrect || 0) + (r.totalIncorrect || 0);
        const pct = total ? Math.round((100 * r.totalCorrect) / total) : 0;
        return (
          <Tag
            style={{
              borderRadius: 999,
              color: "#fff",
              border: "none",
              background: scoreColor(pct),
            }}
          >
            {r.totalCorrect}/{total}
          </Tag>
        );
      },
    },
    {
      title: t("dashboard.colTime"),
      dataIndex: "timeTaken",
      key: "timeTaken",
      width: 100,
      align: "center",
      render: (v) => formatTime(v),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={760}
      destroyOnHidden
      title={`${t("dashboard.ranking")} — ${quiz?.name || ""}${
        classnumber ? ` · ${classnumber}` : ""
      }`}
    >
      {loading ? (
        <div className={styles.center}>
          <Spin />
        </div>
      ) : (
        <Table
          rowKey={(r) => r.studentId}
          dataSource={rows}
          columns={columns}
          pagination={false}
          tableLayout="fixed"
          locale={{ emptyText: t("dashboard.noAttemptsInClass") }}
        />
      )}
    </Modal>
  );
}
